import React from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import Features from "../common/Features";
import Headerstart from "../common/Headerstart";

const FeaturesPage = () => {
  return (
    <>
      <Header />
      <Headerstart link={"Features"} />
      <Features />
      <Footer />
    </>
  );
};

export default FeaturesPage;
